import { useState, useEffect } from 'react';
import { apiClient } from '../../contexts/AuthContext';
import { ChevronDown, ChevronUp } from 'lucide-react';

export function ReglesTab() {
  const [config, setConfig] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => { apiClient.get('/challenge/config').then(r => setConfig(r.data)).catch(() => {}); }, []);
  const toggle = (id) => setOpen(open === id ? null : id);

  const sections = [
    { id: 'structure', title: 'Structure du challenge', content: (
      <div className="space-y-2 text-sm text-[#CCCCCC]">
        <p>Duree : <strong>12 semaines</strong> avec pesees bimensuelles tous les mercredis.</p>
        <p>Donnees mesurees : poids (kg), % masse graisseuse, masse musculaire (kg) via balance impedancemetre.</p>
        {config && (
          <div className="grid grid-cols-4 gap-1.5 mt-3">
            {[{l:'J0',d:config.date_j0},{l:'S2',d:config.date_s2},{l:'S4',d:config.date_s4,c:true},{l:'S6',d:config.date_s6},
              {l:'S8',d:config.date_s8,c:true},{l:'S10',d:config.date_s10},{l:'S12',d:config.date_s12,c:true}].map(x => (
              <div key={x.l} className={`p-2 rounded-md text-center text-xs ${x.c ? 'bg-[#FFB800]/10 border border-[#FFB800]/20' : 'bg-[#0F0F0F]'}`}>
                <p className="font-bold text-white">{x.l}</p>
                <p className="text-[10px] text-[#AAAAAA]">{x.d?.slice(5)}</p>
                {x.c && <p className="text-[9px] text-[#FFB800] mt-0.5">Palier</p>}
              </div>
            ))}
          </div>
        )}
      </div>
    )},
    { id: 'prix', title: 'Les 3 Prix', content: (
      <div className="space-y-3 text-sm text-[#CCCCCC]">
        <div className="p-3 bg-[#FFB800]/10 rounded-md border border-[#FFB800]/20">
          <p className="font-bold text-[#FFB800]">Prix 1 — Recomposition globale</p>
          <p className="text-xs mt-1">Score = (Score_MG x 0.5) + (Score_MM x 0.5). Le plus prestigieux car il faut progresser sur les DEUX axes.</p>
        </div>
        <div className="p-3 bg-[#FF6B35]/10 rounded-md border border-[#FF6B35]/20">
          <p className="font-bold text-[#FF6B35]">Prix 2 — Perte de gras</p>
          <p className="text-xs mt-1">Score = Score_MG. Disqualifie si Score_MM &lt; -5 (perte musculaire excessive).</p>
        </div>
        <div className="p-3 bg-[#FF00B8]/10 rounded-md border border-[#FF00B8]/20">
          <p className="font-bold text-[#FF00B8]">Prix 3 — Prise de muscle</p>
          <p className="text-xs mt-1">Score = Score_MM. Disqualifie si Score_MG &lt; -5 (prise de gras excessive).</p>
        </div>
        <p className="text-xs text-[#AAAAAA]">Anti-cumul : 1 seul prix par participant. Tout le monde est evalue sur les 2 axes.</p>
      </div>
    )},
    { id: 'formules', title: 'Formules de calcul', content: (
      <div className="space-y-2 text-xs text-[#CCCCCC] font-mono bg-[#0F0F0F] rounded-md p-3">
        <p>Score_MG = (MG_J0 - MG_actuel) / MG_J0 x 100</p>
        <p>Score_MM = (MM_actuel - MM_J0) / MM_J0 x 100</p>
        <p>Score_Prix1 = Score_MG x 0.5 + Score_MM x 0.5</p>
        <p className="mt-2 text-[#AAAAAA]">Exemple : MG_J0=25%, MG_actuel=20% → Score_MG = (25-20)/25 x 100 = 20 pts</p>
        <p className="text-[#AAAAAA]">Exemple : MM_J0=55kg, MM_actuel=57kg → Score_MM = (57-55)/55 x 100 = 3.6 pts</p>
      </div>
    )},
    { id: 'gardefous', title: 'Garde-fous (seuil ±5 pts)', content: (
      <div className="space-y-2 text-sm text-[#CCCCCC]">
        <p>Le seuil de -5 points = marge de tolerance (eau, digestion, variabilite balance). Au-dela = vraie derive physique.</p>
        <p>Prix 1 : eligible si Score_MG &gt;= -5 ET Score_MM &gt;= -5</p>
        <p>Prix 2 : eligible si Score_MM &gt;= -5 (pas de perte musculaire excessive)</p>
        <p>Prix 3 : eligible si Score_MG &gt;= -5 (pas de prise de gras excessive)</p>
      </div>
    )},
    { id: 'caution', title: 'Caution 20 000 XPF en 4 paliers', content: (
      <div className="space-y-2 text-sm text-[#CCCCCC]">
        <p>4 paliers de 5 000 XPF chacun :</p>
        <div className="grid grid-cols-4 gap-1.5">
          {[{l:'P1',d:'J0',c:'Inscription'},{l:'P2',d:'S4',c:'33% objectif'},{l:'P3',d:'S8',c:'66% objectif'},{l:'P4',d:'S12',c:'100% objectif'}].map(x => (
            <div key={x.l} className="bg-[#0F0F0F] rounded-md p-2 text-center">
              <p className="font-bold text-white text-xs">{x.l}</p>
              <p className="text-[10px] text-[#AAAAAA]">{x.d}</p>
              <p className="text-[9px] text-[#FF6B35] mt-0.5">{x.c}</p>
            </div>
          ))}
        </div>
        <p className="text-xs text-[#AAAAAA]">Validation : il suffit qu'UNE des 3 routes atteigne la cible du palier (au prorata) : ⚖️ poids −4% OU 🔥 gras −4% OU 💪 muscle +4% par rapport au J0. Palier rate (ou pas de pesee a la date) = perdu definitivement → cagnotte des lots.</p>
      </div>
    )},
    { id: 'departage', title: 'Departage en cas d\'egalite', content: (
      <div className="space-y-1 text-sm text-[#CCCCCC]">
        <p>1. Meilleur Score_MM (valorise la prise de muscle)</p>
        <p>2. Regularite des pesees (nombre de pesees / 6 attendues)</p>
        <p>3. Anciennete d'inscription (le plus ancien gagne)</p>
      </div>
    )},
  ];

  return (
    <div className="p-4 pb-24 space-y-2" data-testid="regles-tab">
      <h2 className="text-2xl text-white mb-3" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>Regles du Challenge</h2>
      {sections.map(s => (
        <div key={s.id} className="bg-[#1B1B1B] border border-[#2A2A2E] rounded-lg overflow-hidden">
          <button onClick={() => toggle(s.id)} className="w-full flex items-center justify-between p-4 text-left" data-testid={`regles-${s.id}`}>
            <span className="text-sm font-semibold text-white">{s.title}</span>
            {open === s.id ? <ChevronUp className="w-4 h-4 text-zinc-400" /> : <ChevronDown className="w-4 h-4 text-zinc-400" />}
          </button>
          {open === s.id && <div className="px-4 pb-4">{s.content}</div>}
        </div>
      ))}
    </div>
  );
}
